'use strict';

export default function (member) {
  let memberName = '';
  switch (parseInt(member & 15)) {
    case 1:
      memberName = '铜牌';
      break;
    case 2:
      memberName = '银牌';
      break;
    case 3:
      memberName = '金牌';
      break;
    case 4:
      memberName = 'Pro';
      break;
    case 5:
      memberName = 'Global';
      break;
    case 6:
      memberName = 'Plus';
      break;
    case 7:
      memberName = 'Luxury';
      break;
    case 8:
      memberName = 'Deluxe';
      break;
  }
  return memberName;
}



// WEBPACK FOOTER //
// ./src/common/filters/user-member.js